import React from "react";
import { utils, writeFile } from "xlsx-js-style";
import CustomInput from "../components/formik/CustomInput";
import CustomSelect from "../components/formik/CustomSelect";
import {
  ServiceBackground,
  ServiceConact,
} from "../components/reports/ServiceColumn";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import {
  getOrderType,
  getReason,
} from "../models/ReportOperatorSalary";
import { getCurrentFortnightNameByCranesOrders } from "../models/ReportByCranesOrders";

const CranesByOrderForm = ({
  formik,
  records,
  cranes,
  operators,
  status,
}) => {
  const baseUrl = window.location.origin;
  
  const exportToExcel = () => {
    const workbook = utils.book_new();

    records
      .filter((record) => record?.orders?.length > 0)
      .map((record) => {
        const crane = record.crane;
        const craneName = crane?.description || "Sin nombre";
        const craneNumber = crane?.crane_number || "";
        const craneTipo = crane?.CraneTypes?.at(0)?.crane_type_name || "";
        const sheetName = `${craneNumber}_${craneName}_${craneTipo}`.substring(0, 30).toUpperCase().replace(/\//g, '_');

        const sheetData = [
          [
            "Folio",
            "Descripción del servicio",
            "Tipo de Servicio",
            "Fecha",
            "Total (Sin IVA)",
            "KM aproximados",
            "Operador",
            "Razón",
          ],
        ];

        let totalSubtotal = 0;
        let totalDistanceSum = 0;

        record.orders.map(({ Order, totalDistance }) => {
          const orderType =
            Order.tipoServicio != null
              ? Order.tipoServicio
              : getOrderType(Order);

          const bg = ServiceBackground({ row: Order });

          const reason = Order.razon?.trim() ? Order.razon : getReason(Order);

          const subtotal = Order.orden_en_cero
            ? 0
            : Number(Order.subtotal) || 0;

          totalSubtotal += subtotal;
          totalDistanceSum += Number(totalDistance) || 0;

          sheetData.push([
            {
              t: "s",
              v: Order.folio.toString().padStart(5, "0"),
              l: {
                Target:
                  Order.tipo === "Varo Express"
                    ? `${baseUrl}/orders-vial/editOrder/${Order.id}`
                    : `${baseUrl}/orders/edit/${Order.id}`,
              },
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: orderType,
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: ServiceConact({ row: Order }),
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: format(new Date(Order.fecha_hora_reporte), "dd/MMM/yyyy", {
                locale: es,
              }),
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "n",
              v: subtotal,
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "n",
              v: Number(totalDistance) || 0,
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v:
                Order.operadores &&
                Order.operadores.length > 0 &&
                Order.operadores[0].User
                  ? `${Order.operadores[0].User.name || ""} ${
                      Order.operadores[0].User.first_surname || ""
                    } ${
                      Order.operadores[0].User.second_surname || ""
                    }`.trim()
                  : Order.operador
                  ? `${Order.operador.name || ""} ${
                      Order.operador.first_surname || ""
                    } ${Order.operador.second_surname || ""}`.trim()
                  : "SIN OPERADOR ASIGNADO",
              s: { fill: { fgColor: { rgb: bg } } },
            },
            {
              t: "s",
              v: reason,
              s: { fill: { fgColor: { rgb: bg } } },
            },
          ]);
        });

        sheetData.push([{ t: "s", v: "" }]);

        sheetData.push([
          { t: "s", v: "Total" },
          { t: "s", v: "" },
          { t: "s", v: "" },
          { t: "s", v: "" },
          { t: "n", v: totalSubtotal },
          { t: "n", v: totalDistanceSum },
          { t: "s", v: "" },
          { t: "s", v: "" },
        ]);

        const worksheet = utils.aoa_to_sheet(sheetData);
        worksheet["!cols"] = [
          { wch: 20 },
          { wch: 35 },
          { wch: 20 },
          { wch: 30 },
          { wch: 20 },
          { wch: 20 },
          { wch: 35 },
          { wch: 35 },
        ];

        utils.book_append_sheet(workbook, worksheet, sheetName);
      });

    const fileName = getCurrentFortnightNameByCranesOrders(
      formik.values.start,
      formik.values.end
    );
    writeFile(workbook,  `GRUAS POR ORDENES ( ${fileName} ).xlsx`);
  };
  return (
    <React.Fragment>
      <div className="row align-items-end gx-1">
        <CustomInput
          label="Fecha inicio"
          field="start"
          type="date"
          formik={formik}
          sm={2}
        />
        <CustomInput
          label="Fecha fin"
          field="end"
          type="date"
          formik={formik}
          sm={2}
        />
        <CustomSelect
          label="Grua"
          field="crane"
          formik={formik}
          options={cranes}
          required
          sm={2}
        />
        <CustomSelect
          label="Operadores"
          field="operator"
          formik={formik}
          options={operators}
          required
          sm={2}
        />
        <CustomSelect
          label="Estatus orden"
          field="status"
          formik={formik}
          options={status}
          required
          sm={2}
        />
        <div className="col-sm-2 d-flex gap-2">
          <button
            className="btn btn-primary w-50"
            onClick={() => formik.handleSubmit()}
          >
            <i className="fa-solid fa-magnifying-glass" />
            &nbsp;Buscar
          </button>
          <button
            className="btn btn-success w-50"
            onClick={() => exportToExcel()}
          >
            <i className="fa-solid fa-file-excel" />
            &nbsp;Descargar
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default CranesByOrderForm;